import { z } from 'zod';
import { defineEndpoint } from '../define';
import { POLL_IMAGE_CONTENT_TYPES, POLL_IMAGE_MAX_BYTES } from './shapes';

export const PollImageUploadBodySchema = z.object({
  contentType: z.enum(POLL_IMAGE_CONTENT_TYPES),
  sizeBytes: z.number().int().min(1).max(POLL_IMAGE_MAX_BYTES),
});
export type PollImageUploadBody = z.infer<typeof PollImageUploadBodySchema>;

export const requestPollImageUploadUrl = defineEndpoint({
  method: 'POST',
  path: '/v1/polls/image-upload-url',
  params: z.object({}),
  query: z.object({}),
  body: PollImageUploadBodySchema,
  response: z.object({
    data: z.object({
      presignedUrl: z.string().url(),
      storagePath: z.string(),
      expiresAt: z.string(),
    }),
  }),
});
